import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, UsersIcon, RefreshCwIcon, TargetIcon } from 'lucide-react';
const BONUSES = [{
  icon: BookOpenIcon,
  title: 'Plantillas de Copy para Ads',
  desc: '+50 plantillas de copy probadas para productos digitales. Solo copiar, pegar y adaptar.',
  value: '$27'
}, {
  icon: TargetIcon,
  title: 'Guía de Ángulos de Venta',
  desc: 'El framework completo para encontrar los ángulos que más venden en tu nicho.',
  value: '$17'
}, {
  icon: UsersIcon,
  title: 'Acceso a Comunidad Privada',
  desc: 'Grupo exclusivo de InfoCommerces y agencias compartiendo resultados y estrategias.',
  value: '$12'
}, {
  icon: RefreshCwIcon,
  title: 'Updates de por Vida',
  desc: 'Cada nueva función, template y mejora que agreguemos. Sin costo extra. Para siempre.',
  value: 'Incalculable'
}];
export function BonusSection() {
  return <section className="py-24 bg-black relative overflow-hidden" data-id="element-21">
      <div className="container mx-auto px-4" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-24">
            Pero eso no es todo...
          </h2>
          <p className="text-xl text-gray-400" data-id="element-25">
            También recibes estos{' '}
            <span className="text-purple-500 font-bold" data-id="element-26">BONUS GRATIS</span> al
            unirte hoy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-27">
          {BONUSES.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="glass-card p-8 rounded-3xl relative overflow-hidden group hover:border-purple-500/40 transition-colors" data-id="element-28">
              <div className="absolute top-6 right-6 bg-purple-500/20 text-purple-300 text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider border border-purple-500/20" data-id="element-29">
                Bonus #{i + 1}
              </div>
              <div className="w-14 h-14 bg-gray-800 rounded-2xl flex items-center justify-center mb-6 text-white group-hover:bg-purple-900/50 transition-colors" data-id="element-30">
                <bonus.icon className="w-7 h-7" data-id="element-31" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-32">
                {bonus.title}
              </h3>
              <p className="text-gray-400 text-sm mb-6 min-h-[40px]" data-id="element-33">
                {bonus.desc}
              </p>
              <div className="text-sm font-medium text-gray-500 flex items-center gap-2" data-id="element-34">
                Valor:{' '}
                <span className="text-gray-300 line-through decoration-red-500/50 text-lg" data-id="element-35">
                  {bonus.value}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}